import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { fetchNews } from "../redux/actions/newsAction";
import { useAppDispatch } from "../redux/hook";
import Pagination from "../utils/Pagination";

export default function News() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // Pagination start
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(3);
  // Pagination end

  const [newsData, setNewsData] = useState({});
  const [loading, setLoading] = useState(true);

  const loadNews = async (page, limit) => {
    const data = {
      page: page,
      limit: limit,
    };

    const news = await dispatch(fetchNews(data));
    if (typeof news.payload === "string" || news.payload === undefined) {
      setLoading(false);
    } else {
      setLoading(false);
      setNewsData(news.payload.news);
      setTotalPages(news.payload.totalPages);
      setTotal(news.payload.total);
      setPage(news.payload.page);
      setLimit(news.payload.limit);
    }
  };

  useEffect(() => {
    loadNews(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative md:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-6 text-center">
          <h3 className="mb-6 md:text-2xl text-xl font-medium">
            {t("external.news.last_news")}
          </h3>

          <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
            {t("external.news.here_there_are_some_of_our_news")}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
          {newsData?.map((item, index) => {
            return (
              <div className="group" key={index}>
                <div className="relative overflow-hidden rounded-xl shadow-md dark:shadow-gray-700">
                  <img
                    src={
                      process.env.REACT_APP_API_URL +
                      "/wwwroot/images/" +
                      item.image_file
                    }
                    className=""
                    alt=""
                  />
                  <div className="absolute inset-0 bg-gradient-to-b to-slate-900 from-transparent opacity-0 group-hover:opacity-100 duration-500"></div>
                  <div className="absolute start-4 bottom-4 opacity-0 group-hover:opacity-100 flex items-center duration-500">
                    <img
                      src={
                        process.env.REACT_APP_API_URL +
                        "/wwwroot/images/" +
                        item.image_file_02
                      }
                      className="h-9 w-9 rounded-xl"
                      alt=""
                    />
                    <div className="ms-2">
                      <Link
                        to={`/news/${item.id}`}
                        className="text-white hover:text-orange-500 text-[15px]"
                      >
                        {item.redactor}
                      </Link>
                      <p className="text-white/70 text-sm">5 Min Read</p>
                    </div>
                  </div>
                </div>

                <div className="p-4">
                  <Link
                    to={`/news/${item.id}`}
                    className="title text-lg font-medium hover:text-orange-500 duration-500"
                  >
                    {item.title}{" "}
                    <span style={{ fontWeight: "100", color: "#929292ff" }}>
                      [{moment(item?.date).format("DD/MM/YYYY")}]
                    </span>
                  </Link>
                  <p className="text-slate-400 dark:text-white/60 mt-3">
                    {item.text}
                  </p>

                  <div className="mt-3">
                    <Link
                      to={`/news/${item.id}`}
                      className="hover:text-orange-500"
                    >
                      {t("external.news.read_more")}{" "}
                      <i className="mdi mdi-arrow-right align-middle"></i>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          limit={limit}
          setLimit={setLimit}
          total={total}
        />
      </div>
    </>
  );
}
